import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useCompactTableContext } from '../../../context/compact-table-context';

export const CompactTableActions = () => {
  const { tableActions } = useCompactTableContext();
  const visibleActions = tableActions?.filter(({ hide = false }) => !hide) || [];

  if (!visibleActions || visibleActions.length === 0) return null;
  return (
    <div css={styles.actionButtonContainer}>
      {visibleActions.map(({ Icon, label, onClick, variant }) => (
        <Button
          key={label}
          variant={variant || 'secondary'}
          color={theme.font.colors.default}
          onClick={() => onClick?.()}
          label={label}
          size='medium'
          css={styles.actionButton}
        >
          {Icon ? <Icon /> : label}
        </Button>
      ))}
    </div>
  );
};

const styles = {
  actionButtonContainer: css`
    gap: ${theme.spacing(1)};
  `,
  actionButton: css`
    border: none;
  `,
};
